// AUTO-GENERATED by scripts/gen-corpus-counts.mjs from
// data/eval-set/<module>/approved.json. Do NOT edit by hand — it is regenerated
// before every learner build (prebuild) and by scripts/promote-to-prod.sh.
// Run `node scripts/gen-corpus-counts.mjs` to refresh after a corpus change.

export const CORPUS_COUNTS: Record<string, number> = {
  trapline: 4102,
  grammar: 2411,
  rubric: 819,
  prompt: 1035,
  slice: 5978,
  science: 2175,
  calc: 350,
  apprecalc: 105,
  act_math: 487,
  act_english: 909,
  act_reading: 1182,
  act_science: 577,
};

/** Total cross-model-validated items across all five modules. */
export const CORPUS_TOTAL = 20130;

/** Date the corpus counts were last regenerated (build/promote time). */
export const CORPUS_UPDATED = "2026-11-03";
